import VacationUserSubordination from 'features/vacations/vacationUserSubordination';
import { useTitle } from '../helpers';

/**
 * @page Vacations subordinates page
 */
const VacationsSubordinationPage = () => {
  useTitle('Информация о подчинённом');

  return (
    <div>
      <h3>Страница информации о подчинённом</h3>
      <VacationUserSubordination />
    </div>
  );
};

export default VacationsSubordinationPage;
